import { type FC } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';

import { trackItemFavoritingSuccessToastCtaClick } from './tracking.ts';

import styles from './styles/PortfolioToast.scss';
import dibsCss from 'dibs-css';

const AddToFolderToastContent: FC<{
    portfolioId: string;
    portfolioName: string;
    favoritesPageRedesignFF?: boolean;
}> = ({ portfolioId, portfolioName, favoritesPageRedesignFF }) => (
    <div
        className={classNames(
            dibsCss.flex,
            dibsCss.justifyBetween,
            dibsCss.itemsCenter,
            dibsCss.gapSmall
        )}
    >
        <span className={dibsCss.sassyFontBodySmallHeavy}>
            {favoritesPageRedesignFF ? (
                <FormattedMessage
                    id="itemFavoriting.FolderToastsContent.collection.add"
                    defaultMessage="Added To Your{hasPortfolioName, select, true { “{portfolioName}”} other {}} Collection"
                    values={{ portfolioName, hasPortfolioName: !!portfolioName }}
                />
            ) : (
                <FormattedMessage
                    id="itemFavoriting.FolderToastsContent.add"
                    defaultMessage="Added To Your{hasPortfolioName, select, true { “{portfolioName}”} other {}} Folder"
                    values={{ portfolioName, hasPortfolioName: !!portfolioName }}
                />
            )}
        </span>
        {portfolioId && (
            <Link
                href={`/favorites/folders/${portfolioId}/`}
                target="_blank"
                className={classNames(styles.link, dibsCss.sassyFontBodySmallHeavy)}
                onClick={() => trackItemFavoritingSuccessToastCtaClick({ trigger: 'view folder' })}
            >
                {favoritesPageRedesignFF ? (
                    <FormattedMessage
                        id="itemFavoriting.FolderToastsContent.collection.add.link"
                        defaultMessage="View Collection"
                    />
                ) : (
                    <FormattedMessage
                        id="itemFavoriting.FolderToastsContent.add.link"
                        defaultMessage="View Folder"
                    />
                )}
            </Link>
        )}
    </div>
);

const RemoveFromFolderToastContent: FC<{
    portfolioName: string;
    favoritesPageRedesignFF?: boolean;
}> = ({ portfolioName, favoritesPageRedesignFF }) => (
    <div className={dibsCss.sassyFontBodySmallHeavy}>
        {favoritesPageRedesignFF ? (
            <FormattedMessage
                id="itemFavoriting.FolderToastsContent.collection.remove"
                defaultMessage="Removed From {hasPortfolioName, select, true {“{portfolioName}”} other {collection}}"
                values={{ portfolioName, hasPortfolioName: !!portfolioName }}
            />
        ) : (
            <FormattedMessage
                id="itemFavoriting.FolderToastsContent.remove"
                defaultMessage="Removed From {hasPortfolioName, select, true {“{portfolioName}”} other {folder}}"
                values={{ portfolioName, hasPortfolioName: !!portfolioName }}
            />
        )}
    </div>
);

export { AddToFolderToastContent, RemoveFromFolderToastContent };
